// extracted by mini-css-extract-plugin
export default {"background":"PromoCodeSection-module_background_rOeKSrQ2BM","homechef":"PromoCodeSection-module_homechef_VAHVnSlBCz","tempo":"PromoCodeSection-module_tempo_CCRAf1Ny2p"};